export const FLEETCOR = "fleecor";
export const FLEET_ADVISE = "fleetadvise";

export const FLEET_ROLE = Object.freeze({
  DRIVER: "Driver",
});
